import {Component, DoCheck, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Customer} from '../../../Models/Customer/Customer';
import {BaseDetailComponent} from '../../common/BaseDetailComponent';
import {NgForm} from "@angular/forms";

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customerDetail.component.html',
  styleUrls: ['./customerDetail.component.css']
})
export class CustomerDetailComponent extends BaseDetailComponent implements DoCheck {

  @Input('selectedRow') selectedRow?: any;
  @Input('editMode') editMode?: boolean;

  @Output() close = new EventEmitter();
  @Output() validForm = new EventEmitter<boolean>();

  dataDetail?: Customer;
  emailList: string = '';


  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('updateForm') updateForm!: NgForm;

  ngDoCheck(): void {
    this.validForm.emit(!this.updateForm?.invalid);
  }

  resetImage() {
    super.resetImage();
    if (!!this.dataDetail) {
      this.dataDetail.imageUrl = undefined;
    }

    if (!!this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    // Overrides behavior in order to initialize datepickers
    if (changes.selectedRow && !!this.selectedRow) {

      if (!!this.dataDetail?.emails && this.dataDetail.emails.length > 0) {
        this.emailList = this.dataDetail.emails.reduce((a: string, b: string) => `${a}, ${b}`);
      } else {
        this.emailList = '';
      }

    }

  }

  createEmailList(emailList: string, invalid: boolean | null) {
    if (!invalid && !!this.dataDetail) {
      if (emailList.length > 0 ) {
          this.dataDetail.emails = emailList.split(',');
          console.log(this.dataDetail.emails);
      } else {
        this.dataDetail.emails = new Array<string>();
      }
    }

    console.log(this.dataDetail?.emails);
  }
}
